function e(e,t){return t.get?t.get.call(e):t.value}export{e as default};
